import React, { useState } from "react";
import {
  Grid,
  Input,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import PropTypes from "prop-types";

const USER_TYPE_OPTIONS = [
  { value: "ORG_ADMIN", label: "Org Admin (Full)" },
  { value: "TEAM_MEMBER", label: "Team Member (Lite)" },
];

function EditUserForm({ userp, handleResponse }) {
  const [firstName, setFirstName] = useState(userp?.user?.first_name || "");
  const [lastName, setLastName] = useState(userp?.user?.last_name || "");
  const [userType, setUserType] = useState(userp?.user?.type || "ORG_ADMIN");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const issues = {};
    if (!firstName.trim()) issues.firstName = "*Please enter First Name.";
    if (!lastName.trim()) issues.lastName = "*Please enter Last Name.";
    setErrors(issues);
    return Object.keys(issues).length === 0;
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (validate()) {
      setConfirmOpen(true);
    }
  };

  const handleConfirm = () => {
    setConfirmOpen(false);
    handleResponse({
      userId: userp.user.id,
      first_name: firstName,
      last_name: lastName,
      type: userType,
    });
  };

  return (
    <>
      <form className="b-modal-container" onSubmit={handleSave}>
        <Grid container spacing={4} className="b-modal-container__form">
          <Grid item xs={12}>
            <InputLabel
              htmlFor="edit_first_name"
              className="font-bold b-organization-container__label"
            >
              First Name
            </InputLabel>
            <Input
              id="edit_first_name"
              className="dafault-font-family b-organization-container__input"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            {errors.firstName && (
              <div className="errorMsg">{errors.firstName}</div>
            )}

            <div className="b-organization-container__detailHead">
              <InputLabel
                htmlFor="edit_last_name"
                className="font-bold b-organization-container__companyLabel"
              >
                Last Name
              </InputLabel>
              <Input
                id="edit_last_name"
                className="dafault-font-family b-organization-container__companyname"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              {errors.lastName && (
                <span className="errorMsg">{errors.lastName}</span>
              )}
            </div>

            <div className="b-organization-container__label-div">
              <InputLabel
                htmlFor="edit_user_type"
                className="font-bold b-organization-container__label"
              >
                User Type
              </InputLabel>
              <Select
                id="edit_user_type"
                value={userType}
                onChange={(e) => setUserType(e.target.value)}
                variant="standard"
                className="dafault-font-family b-organization-container__input"
              >
                {USER_TYPE_OPTIONS.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <div className="b-organization-container__buttonHead padding-bottom">
              <Button
                type="submit"
                className="b-btn-container__btn-add-new"
                variant="outlined"
              >
                Save Changes
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Confirm Update</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to update{" "}
            <strong>
              {firstName} {lastName}
            </strong>
            &apos;s profile?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button onClick={handleConfirm} variant="contained">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

EditUserForm.propTypes = {
  userp: PropTypes.shape({
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      type: PropTypes.string,
    }).isRequired,
  }).isRequired,
  handleResponse: PropTypes.func.isRequired,
};

export default EditUserForm;
